"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const security_error_1 = require("./security-error");
/**
 * Exception thrown when a not allowed filter is used in a template.
 *
 * @author Eric MORAND <eric.morand@gmail.com>
 */
class TwingSandboxSecurityNotAllowedFilterError extends security_error_1.TwingSandboxSecurityError {
    constructor(message, functionName, lineno = -1, filename = null) {
        super(message, lineno, filename);
        this.filterName = functionName;
        this.name = 'TwingSandboxSecurityNotAllowedFilterError';
    }
    getFilterName() {
        return this.filterName;
    }
}
exports.TwingSandboxSecurityNotAllowedFilterError = TwingSandboxSecurityNotAllowedFilterError;
